import styled, { css } from 'styled-components';
import mq from '../../utils/mediaQueries.js';

// @ts-nocheck
var EsgLogo = styled.div.withConfig({
  displayName: "style__EsgLogo",
  componentId: "sc-i4qmqz-0"
})(["display:inline-flex;height:auto;align-self:flex-start;", " img{height:auto;width:50px;", " ", "}"], function (props) {
  return props.onClick && css(["cursor:pointer;"]);
}, function (props) {
  return props.$mobileSize && css(["width:", "px;"], props.$mobileSize);
}, mq.s(css(["width:64px;", ""], function (props) {
  return props.$desktopSize && css(["width:", "px;"], props.$desktopSize);
})));

export { EsgLogo };
//# sourceMappingURL=style.js.map
